import React from 'react';

import {PaymentFooterWrapper} from '../../common/paymentFooter/paymentFooterWrapper';
import {PaymentWrapper} from '../../common/paymentWrapper/paymentWrapper';

/**
 * Empty payment block
 */
export const PaymentEmpty = () => {
    return (
        <>
            <PaymentWrapper showSkeleton />
            <PaymentFooterWrapper isLoading />
        </>
    );
};
